import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleError } from "../../../../utils/ErrorHandler";

const initialState = {
  list: [],
  holiday: null,
  error: "",
  isSubmittingHoliday: false,    // For getAllGames
  isFetchingSingle: false, // For getGameById
  isSubmitting: false,     // For createGame and updateGame
  isDeleting: false,       // For deleteGame
};

// Get all holidays (paginated)
export const getAllHolidays = createAsyncThunk(
  "holiday/getAllHolidays",
  async (franchiseId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/holiday?franchiseId=${franchiseId}`);
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to fetch all holidays");
      return rejectWithValue(errorMessage);
    }
  }
);

// Get holiday by ID


// Create holiday
export const addHoliday = createAsyncThunk(
  "holiday/createHoliday",
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`holiday`, values);
      toast.success("Holiday added successfully!");
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to add holiday");
      return rejectWithValue(errorMessage);
    }
  }
);

// Update holiday
export const updateHoliday = createAsyncThunk(
  "holiday/updateHoliday",
  async ({id, values}, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`/holiday/${id}`, values);
      toast.success("Holiday updated successfully!");
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to update holiday");
      return rejectWithValue(errorMessage);
    }
  }
);

// Delete holiday


const holidaySlice = createSlice({
  name: "holiday",
  initialState,
  reducers: {
    clearGame: (state) => {
      state.holiday = null;
    },
  },
  extraReducers: (builder) => {
    // getAllGames
    builder.addCase(addHoliday.pending, (state) => {
      state.isSubmittingHoliday = true;
      state.error = "";
    });
    builder.addCase(addHoliday.fulfilled, (state, action) => {
      state.isSubmittingHoliday = false;
      state.list = action.payload;
    });
    builder.addCase(addHoliday.rejected, (state, action) => {
      state.isSubmittingHoliday = false;
      state.error = action.payload;
    });
    // updateHoliday
    builder.addCase(updateHoliday.pending, (state) => {
      state.isSubmittingHoliday = true;
      state.error = "";
    });
    builder.addCase(updateHoliday.fulfilled, (state, action) => {
      state.isSubmittingHoliday = false;
      state.list = action.payload;
    });
    builder.addCase(updateHoliday.rejected, (state, action) => {
      state.isSubmittingHoliday = false;
      state.error = action.payload;
    });
  },
});

export default holidaySlice.reducer;
export const { clearGame } = holidaySlice.actions;